import script from "./NotificationsComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./NotificationsComponent.vue?vue&type=script&lang=ts&setup=true"

import "./NotificationsComponent.vue?vue&type=style&index=0&id=58e10fd4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e10fd4"]])

export default __exports__